// @ts-nocheck
import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PinInput, Group as MantineGroup } from '@mantine/core';
import { Stack, Center, Group } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { IconArrowLeft, IconDeviceMobile } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function OtpClassicMinimal() {
  const [otp, setOtp] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  const handleChange = (value: string) => {
    setOtp(value);
    if (value.length === 6) {
      setIsComplete(true);
    } else {
      setIsComplete(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('OTP submitted:', otp);
  };

  return (
    <AuthLayoutWrapper variant="simple">
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/otp"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 56,
                height: 56,
                borderRadius: 14,
                backgroundColor: 'var(--mantine-color-violet-light)',
              }}
            >
              <IconDeviceMobile size={28} color="var(--mantine-color-violet-6)" />
            </Center>
            <Title order={2} ta="center">Verification code</Title>
            <Text c="dimmed" size="sm" ta="center" maw={300}>
              We've sent a 6-digit code to your phone ending in **42
            </Text>
          </Stack>
        </Center>

        {/* OTP Input */}
        <form onSubmit={handleSubmit}>
          <Stack gap="lg">
            <Center>
              <PinInput
                length={6}
                size="lg"
                value={otp}
                onChange={handleChange}
                type="number"
                oneTimeCode
                aria-label="Verification code"
              />
            </Center>

            <Button type="submit" fullWidth disabled={!isComplete}>
              Verify code
            </Button>
          </Stack>
        </form>

        {/* Resend */}
        <Text ta="center" size="sm" c="dimmed">
          Didn't receive the code?{' '}
          <Anchor component="button" type="button" fw={500}>
            Resend
          </Anchor>
        </Text>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/app/demo/auth-pages/login/simple" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to login
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
